module.exports = __webpack_public_path__ + "static/media/profile5.2b83c57e.png";